module.exports = __webpack_public_path__ + "img/26.b1f98187.jpg";